import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Header from "./Themes/Main/Header.jsx";
import Sitebar from "./Themes/Main/Sitebar.jsx";
import Footer from "./Themes/Main/Footer.jsx";
import Account from "./Themes/Account";
import LoginPage from "./Components/Account/Login/Login.jsx";
import ForgetPage from "./Components/Account/Login/Forget";
import NewPasswordPage from "./Components/Account/Login/NewPassword";
import SmsPage from "./Components/Account/Sms/";
import AdminRouter from "./Pages/Admin/router";
import { ThemeProvider } from "./Components/Theme/ThemeContext";
import ServiceWorkerUpdate from "./Components/ServiceWorkerUpdate";
import ImpersonationBanner from "./Components/ImpersonationBanner";

import VerficationPage from "./Components/Account/SignUp/Confirmation.jsx";
import InviteAcceptPage from "./Pages/Invite/accept";
import { RequireAuth } from "./Auth/require_auth";
import { RequireAuthAdmin } from "./Auth/require_auth_admin";
import { RequireAuthRoles } from "./Auth/require_auth_roles";

import NoMatch from "./Themes/Main/404";
import HelpPage from "./Pages/Help";

import Loading from "./Components/loading/messages";
import MainPage from "./Pages/index";
import { settranslate } from "./Components/Lib/Languages/language";
import ItemRouter from "./Pages/Items/router.js";
import EventRouter from "./Pages/Evemenenten/router.js";
import ErvaringenRouter from "./Pages/Ervaringen/router.js";
import BoekingenRouter from "./Pages/Boekingen/router.js";
import CMSRouter from "./Pages/CMS/router";
import VacaturesRouter from "./Pages/Vacatures/router.js";
import ArrangementenRouter from "./Pages/Arrangementen/router.js";

const App = () => {
  const location = useLocation();
  const loc = location.pathname.split("/");

  useEffect(() => {
    settranslate();
    if (location.key) {
      document.body.classList.remove("sidebar-open");
    }
  }, [location]);

  if (loc[1] === "help") {
    return (
      <ThemeProvider>
        <Routes>
          <Route exact path="/help" element={<HelpPage />} />
        </Routes>
      </ThemeProvider>
    );
  }

  if (loc[1] === "login" || loc[1] === "signup" || loc[1] === "404" || loc[1] === "invite") {
    return (
      <ThemeProvider>
        <Account>
          <Routes>
            <Route exact path="/login" element={<LoginPage />} />
            <Route exact path="/login/sms/:token" element={<SmsPage />} />
            <Route exact path="/login/forget" element={<ForgetPage />} />
            <Route exact path="/login/forget/:code" element={<NewPasswordPage />} />
            <Route exact path="/signup/verify/:code" element={<VerficationPage />} />
            <Route exact path="/invite/accept/:token" element={<InviteAcceptPage />} />
            <Route exact path="/404" element={<NoMatch />} />
          </Routes>
        </Account>
      </ThemeProvider>
    );
  } else {
    return (
      <ThemeProvider>
        <React.Fragment>
          <ServiceWorkerUpdate />
          <ImpersonationBanner />
          <div className="sneat-layout">
            <Header />
            <Sitebar />
            <div className="sneat-content-wrapper">
              <Loading />
              <section className="content">
                <Routes>
                  <Route
                    exact
                    path="/"
                    element={
                      <RequireAuth>
                        <MainPage />
                      </RequireAuth>
                    }
                  />

                  <Route
                    path="/admin/*"
                    element={
                      <RequireAuthAdmin>
                        <AdminRouter />
                      </RequireAuthAdmin>
                    }
                  />
                  <Route
                    path="/items/*"
                    element={
                      <RequireAuthRoles roles={["admin", "manager", "medewerker", "locatiebeheerder"]}>
                        <ItemRouter />
                      </RequireAuthRoles>
                    }
                  />
                  <Route
                    path="/evenementen/*"
                    element={
                      <RequireAuthRoles roles={["admin", "manager", "medewerker"]}>
                        <EventRouter />
                      </RequireAuthRoles>
                    }
                  />
                  <Route
                    path="/ervaringen/*"
                    element={
                      <RequireAuth>
                        <ErvaringenRouter />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="/boekingen/*"
                    element={
                      <RequireAuth>
                        <BoekingenRouter />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="/cms/*"
                    element={
                      <RequireAuthRoles roles={["admin", "manager", "medewerker"]}>
                        <CMSRouter />
                      </RequireAuthRoles>
                    }
                  />
                  <Route
                    path="/vacatures/*"
                    element={
                      <RequireAuthRoles roles={["admin", "manager", "medewerker"]}>
                        <VacaturesRouter />
                      </RequireAuthRoles>
                    }
                  />
                  <Route
                    path="/arrangementen/*"
                    element={
                      <RequireAuth>
                        <ArrangementenRouter />
                      </RequireAuth>
                    }
                  />
                  <Route path="*" element={<NoMatch />} />
                </Routes>
              </section>
            </div>
          </div>
          <Footer className="main-footer" />
        </React.Fragment>
      </ThemeProvider>
    );
  }
};

export default App;
